import { useMemo } from "react";
import { createDetailsListColumnFactory, detailsListColumnWidths as cw } from "@advosys/component-react";
import { useT } from "./time-track-entries-i18n";
const cf = createDetailsListColumnFactory();
export const useTimeTrackEntriesColumns = () => {
    const { t } = useT();
    const columns = useMemo(() => [
        cf("date", t.columnDate, cw.date, item => item.date, { filter: { filterKind: "dateinterval", handling: { getItemFilterValue: x => x.date } } }),
        cf("employeeId", t.columnEmployee, cw.shortText, item => item.employeeId, { filter: { filterKind: "selectvalues", handling: { getItemFilterValue: x => x.employeeId } } }),
        cf("billableAmountMinutes", t.billableAmountMinutes, cw.date, item => item.billableAmountMinutes, { format: "m", justifyContent: "flex-end", footer: "sum" }),
        cf("activityDescription", t.columnActivityDescription, cw.mediumText, item => item.activityDescription ?? ""),
        cf("billableAmount", t.columnBillableAmount, cw.smallDecimal, item => item.billableAmount, {
            format: "b2",
            justifyContent: "flex-end",
            footer: "sum"
        })
    ], [t]);
    return { columns };
};
